import moment from 'moment';
import { AnimatePresence, motion } from 'framer-motion';
import { Row, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';
import { CheckIcon } from '~/images/icons/CheckIcon';

interface IAutoSaveStatusProps {
  visible?: boolean;
  date?: Date | null;
}

export const AutoSaveStatus = ({ visible = false, date }: IAutoSaveStatusProps) => {
  const formattedDate = date ? moment(date).format('hh:mm a') : '';

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{
            duration: 0.4,
            ease: [0.4, 0, 0.2, 1],
          }}
          style={{
            position: 'fixed',
            top: 110,
            right: 50,
            zIndex: 10,
          }}
        >
          <Row
            alignItems="center"
            data-cy="auto-save-status"
            paddingHorizontal={10}
            borderRadius={12}
            border={`1px solid ${Colors.neutral_200}`}
            backgroundColor={Colors.white}
            boxShadow="0 2px 8px rgba(0, 0, 0, 0.1)"
          >
            <CheckIcon size={20} color={Colors.success_500} />
            <Text fontSize={15}>Draft saved • {formattedDate}</Text>
          </Row>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
